import React, { useMemo } from 'react';
import {
  servicesConstants, useFeatureFlagsContext, useI18n, useRootContext, useServicesQuery,
} from '@jarvis/react-portal-addons';
import GenericThemeProvider from '../../../shared/GenericThemeProvider';
import {
  Container, Grid, PrintAnywhereContainer, SideCardsContainer,
} from './styles';
import useDeviceCacheApiCall from '../../../hooks/useDeviceCacheApiCall';
import Banner from '../Banner';
import { AdminsWidget } from '../AdminsWidget';
import { WorkspaceWidget } from '../WorkspaceWidget';
import PrintAnywhereWidget from '../PrintAnywhereWidget';

const EndUserConsolidatedDashboard = () => {
  const { shell, stack } = useRootContext();
  const { t } = useI18n();

  const { authProvider } = shell;

  const deviceCache = useDeviceCacheApiCall({
    authProvider,
    stack,
    init: true,
  });

  const { consolidatedPortalCheckAdvancedViewGrant } = useFeatureFlagsContext();

  const { SERVICE_TYPES, SERVICE_STATES } = servicesConstants;

  const advancedViewQuery = useMemo(
    () => ({
      type: SERVICE_TYPES.GRANTS,
      services: [
        {
          id: 'advancedView',
          states: [SERVICE_STATES.ENABLED],
          serviceIds: ['solution.client.portal/advanced-view'],
        },
      ],
    }),
    [SERVICE_TYPES.GRANTS, SERVICE_STATES.ENABLED],
  );

  const { helpers: servicesHelpers } = useServicesQuery(advancedViewQuery);

  const hasAdvancedGrant = servicesHelpers?.checkService({ id: 'advancedView' });

  return (
    <GenericThemeProvider>
      <Container data-testid="end-user-dashboard">
        <Banner
          data-testid="banner-container" deviceCache={deviceCache}
          showNotifications={false}
        />

        <Grid>
          <PrintAnywhereContainer data-testid="print-anywhere-container">
            <PrintAnywhereWidget stack={stack} />
          </PrintAnywhereContainer>

          <SideCardsContainer data-testid="side-cards-container">
            {consolidatedPortalCheckAdvancedViewGrant && !hasAdvancedGrant ? (
              <AdminsWidget title={t('dashboard.printerOwnersListCard.header')} />
            ) : (
              <>
                <AdminsWidget title={t('dashboard.adminsListCard.header')} />
                <WorkspaceWidget />
              </>
            )}
          </SideCardsContainer>

        </Grid>
      </Container>
    </GenericThemeProvider>
  );
};

export default EndUserConsolidatedDashboard;
